__webpack_require__.p = "/shopping-list/";